module.exports = __webpack_public_path__ + "img/ch84.08de98dd.jpg";